/* multibyte counting, for multibyte strings, emojis, unicode, etc... string.length wouldn't work */
export const countMultibyte = (text: string): number => [...text].length
